import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { ContentUnitApiResponse, ContentUnitTemplateApiResponse } from '../models/content-unit.model'

@Injectable({
  providedIn: 'root'
})
export class ContentUnitService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.cuApiUrl

  public getById(uuid: string): Observable<ContentUnitApiResponse> {
    return this.http.get<ContentUnitApiResponse>(`${this.apiUrl}/${uuid}`)
  }

  public listAll(): Observable<ContentUnitApiResponse[]> {
    return this.http.get<ContentUnitApiResponse[]>(`${this.apiUrl}/list`)
  }

  public create(data: ContentUnitApiResponse): Observable<ContentUnitApiResponse> {
    return this.http.post<ContentUnitApiResponse>(this.apiUrl, data)
  }

  public update(data: ContentUnitApiResponse): Observable<ContentUnitApiResponse> {
    return this.http.put<ContentUnitApiResponse>(`${this.apiUrl}/${data.uuid}`, data)
  }

  public checkContentUnitExists(title: string): Observable<boolean> {
    return this.http.get<{ exist: boolean }>(`${this.apiUrl}/exist`, {
      params: { title }
    }).pipe(
      map(response => response.exist)
    )
  }

  public getTags(q: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/tags`, {
      params: { q }
    })
  }

  public getTemplatesByContentUnitId(uuid: string): Observable<ContentUnitTemplateApiResponse[]> {
    return this.http.get<ContentUnitTemplateApiResponse[]>(`${this.apiUrl}/templatesByContentUnitId`, {
      params: { id: uuid }
    })
  }

  public save(data: ContentUnitApiResponse): Observable<ContentUnitApiResponse> {
    const uuidValue = data.uuid

    const hasUuid = uuidValue !== null &&
      uuidValue !== undefined
    return hasUuid
      ? this.update(data)
      : this.create(data)
  }
}
